import React from "react";
import bgvideo from "../assests/video-1.mp4";
import "./Banner.css";
import Button from "./Button";

export default function Banner(props) {
  return (
    <>
      <div className="container-fluid banner-container">
        { props.btype === "video" ? <video src={props.src} muted loop autoPlay /> : <img className="banner-image" src={props.src}/> }
        <div className="banner-overlay">
          <h1 className="banner-heading">{props.heading}</h1>
          <p className="banner-subhead">{props.subheading}</p>
          {/* <button>GET STARTED</button> */}
          {props.showButton && <>
            <Button text="Get Started" btype="normal"/>
          <Button text="Watch Trailer" btype="video"/>
          </>}
          
        </div>
      </div>
    </>
  );
}
